<template>
    <button 
        type="submit"
        class="btn btn-submit"
        :disabled="working || disabled"
        @click.prevent="e => $emit('click', e)">
        <template v-if="working">{{ workingLabel }}</template>
        <slot v-else>{{ defaultLabel }}</slot>
    </button>
</template>

<script>
export default {
    props: {
        defaultLabel: {
            type: String,
            default: 'Save',
        },
        workingLabel: {
            type: String,
            default: 'Saving',
        },
        working: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>